/*!
=========================================================
* 依頼（駐車場）登録
=========================================================
*/
import React from "react";

import {
  Button,
  Card, CardHeader, CardBody, CardTitle,
  Input,
  Table, Row, Col,
  Modal, ModalHeader, ModalBody, ModalFooter
} from "reactstrap";
import InputText from '../FormParts/InputText'
import InputNumber from '../FormParts/InputNumber'
import InputRadio from '../FormParts/InputRadio'
import InputDatetime from '../FormParts/InputDatetime'
import InputSelect from '../FormParts/InputSelect';
import InputCheckBox from '../FormParts/InputCheckBox';
import Request from '../../common/Request';
import CustomTd from '../ViewParts/CustomTd';
import GsuiteAuth from '../../components/Auth/GsuiteAuth';
import WithRole from '../FormParts/ButtonWithRole';
import Definition from '../../common/Definition';
import CustomerSelectPopupWithOrder from '../ViewParts/CustomerSelectPopupWithOrder';

import {
  cst_want_guide_type,
  cst_auto_order_function_flag,
  cst_register_type,
} from '../../variables/codes_map';
import { GetMessage, getErrorCodes } from "../../variables/message";
import format_url from '../../variables/format_url';
import GoogleDrive from "../../common/GoogleDrive"
import { select } from "underscore";
import { template } from "../../variables/memoTemplate";

var domain = "";
const moment = require("moment");

class Regist extends React.Component {
  constructor(props) {
    super(props);

    const box_status = new URL(window.location.href).searchParams.get("box_status")
    // 遷移先に遷移元を示すパラメータを渡す
    const box_status_param = `?box_status=${box_status}`
    // 遷移元に戻るための設定
    const transition_url = box_status === "0" ? "/construction/list" : "/construction/new_customer";
    this.state = {
      regist_modal: false,
      sub_regist_modal: false,
      error_modal: false,
      copy_modal: false,
      view: false,
      valid: true,
      data: {
        values: {
          request_date: moment().format("YYYY-MM-DDT00:00:00"),
          estimate_deadline: moment().add(10, 'days').format("YYYY-MM-DDT00:00:00"),
          register_type: cst_register_type[0].default,
          want_guide_type: cst_want_guide_type[0].default,
          want_guide_type_subcontract: cst_want_guide_type[0].default,
          extend_estimate_natural_id: "",
          temp_contact_memo: template[0].value,
          auto_order_display_flag: 0
        },
        errors: {},
        requiredData: {}
      },
      project: {
        customer_user: {
          customer: {}
        }
      },
      request: {},
      customer1: {},
      customer2: {},
      request_type: "",
      want_start_date_disable: false,
      userData: [],
      modalData: [],
      customerSystemUseFlag: false,
      box_status: box_status,
      box_status_param: box_status_param,
      transition_url: transition_url,
      regist_lock: false,
      regist_yes_lock: false,
    };

    this.toggleRegistModal = this.toggleRegistModal.bind(this);
    this.validateCallback = this.validateCallback.bind(this)
    this.calculate_SUM_request_parking_qty = this.calculate_SUM_request_parking_qty.bind(this)
    this.alertDateCheck = this.alertDateCheck.bind(this)
    // #1189 追加
    this.toggleCopyModal = this.toggleCopyModal.bind(this);
    this.selectCopyData = this.selectCopyData.bind(this);
    this.customer_select_popup = React.createRef();
    this.customerSelected = this.customerSelected.bind(this);
  }

  // 初期ロード用
  async componentDidMount() {
    /*　ここは開発者が記述　*/
    let workday;
    if (this.props.match.params.others_type !== undefined) {
      var others_type = this.props.match.params.others_type;

      // 新規登録の場合、見積提出期限を+10営業日設定
      workday = await new Promise(resolve => {
        Request.get('/api/workday', { add_day: 10 }, res => {
          resolve(res.Data)
        })
      })
      // if (workday === undefined){
      //   workday = ""
      // }
      this.setState({
        request_type: others_type,
        data: {
          ...this.state.data,
          values: {
            ...this.state.data.values,
            request_type: others_type,
            estimate_deadline: workday ? moment(workday).format("YYYY-MM-DDT00:00:00") : ""
          }
        },
      });
    }

    await this.search();

    // #2651 修正対応
    // others_type URLパラメータの為、新規登録時のみセットされる
    if (this.props.match.params.others_type !== undefined) {
      
      // 新規登録かつ延長の場合、
      // 依頼受付日も考慮
      // 見積提出期限を+10営業日設定
      if (Number(others_type) === 2 && this.state.view === false) {
        this.setState({
          request_type: others_type,
          data: {
            ...this.state.data,
            values: {
              ...this.state.data.values,
              request_type: others_type,
              request_date: moment().format("YYYY-MM-DDT00:00:00"),
              estimate_deadline: workday ? moment(workday).format("YYYY-MM-DDT00:00:00") : ""
            }
          }
        })
      }

    }
    const requiredCheckedData = await Request.getRequiredData('/api/request', this.state.data)
    this.setState({
      data: requiredCheckedData
    })
    // #1189
    await this.request_modal_data();

    const usersUrl = '/api/landmark/user';
    Request.get(usersUrl, {}, res => {

      const isUpdate = window.location.href.split("/").includes("update")

      if (isUpdate) {
        this.setState((prevState) => {
          return {
            ...prevState,
            userData: res.Data,
          }
        })
      } else {
        this.setState((prevState) => {
          return {
            ...prevState,
            userData: res.Data,
            data: {
              ...prevState.data,
              values: {
                ...prevState.data.values,
              }
            }
          }
        })
      }
    })

    // 担当支店用にランドマーク支店マスタの取得
    Request.get("/api/landmark/user_branch", {}, res => {
      const user_branch_list = res.Data.map((prop, key) => {
        return {
          value: prop.user_branch_natural_id,
          label: prop.user_branch_name,
          user_branch_natural_id: prop.user_branch_natural_id,
          id: prop.id
        }
      })
      this.setState({ landmark_user_branch: user_branch_list });
    })
  }
  // #1189　見積選択用データの取得
  request_modal_data() {
    // console.log("request_modal_data",this.state.project);

    const {
      project_natural_id
    } = this.state.project

    const params = {
      project_natural_id,
      copy_extention_flag: 1,
      survey_status: 3,
      request_type: [0, 1, 2] // 0:初回、1:追加、2:延長、3:積替、4:道路使用許可、5:取扱説明書収納、6:電線移設
    }
    Request.get('/api/order', params, (res) => {
      // console.log(res.Data);
      this.setState({
        modalData: this.mapModalData(res.Data)
      });
    })
  }
  mapModalData(data) {
    return data.map((data_) => {
      return ({
        ...data_,
        copy_flg: false
      });
    });
  }

  search() {
    return (async () => {
      const projectUrl = domain + '/api/construction/' + this.props.match.params.project_id + "?project_only=true";
      const requestUrl = domain + '/api/request/' + this.props.match.params.request_seq;

      // 追加時
      const requestAddUrl = domain + '/api/request?project_ulid=' + this.props.match.params.project_id + "&request_type=1&all_survey_status=1";
      // 延長時
      const requestExtUrl = domain + '/api/request?estimate_natural_id=' + this.props.match.params.estimate_natural_id + '&all_survey_status=true';

      const res = (this.props.match.params.project_id !== undefined) ?
        (this.props.match.params.estimate_natural_id !== undefined) ?
          // 延長時
          await new Promise((resolve, reject) => Request.get(requestExtUrl, {}, result => {
            const res = { Data: result.Data[0] }
            const customerSystemUseFlag = res.Data.customer_system_use_flag;
            if (this.props.data_view_flag == 2 && (res.Data.user_branch_id != GsuiteAuth.get('user_branch_id'))) {
              this.props.pageChangeAlert.current.inactivate();
              this.props.history.push('/forbidden')
              return
            } else {
              const defaultWantGuideTypeSubcontract = res.Data.want_guide_type_subcontract === null ? cst_want_guide_type[0].default : res.Data.want_guide_type_subcontract;
              this.setState({
                data: {
                  ...this.state.data,
                  values: {
                    ...res.Data,
                    request_natural_id: undefined,
                    id: undefined,
                    survey_status: 0,
                    want_start_date: "",
                    want_end_date: "",
                    estimate_create_start_date: undefined,
                    want_guide_type_subcontract: defaultWantGuideTypeSubcontract,
                  }
                },
                project: res.Data,
                customerSystemUseFlag: customerSystemUseFlag
              }, () => {
                this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.project)
              })
            }
            resolve(res)
          }, () => reject()))
          :
          (this.props.match.params.others_type == "1") ?
            // 追加時
            await new Promise((resolve, reject) => Request.get(requestAddUrl, {}, result => {
              const res = { Data: result.Data[0] }
              const customerSystemUseFlag = res.Data.customer_system_use_flag;
              if (this.props.data_view_flag == 2 && (res.Data.user_branch_id != GsuiteAuth.get('user_branch_id'))) {
                this.props.pageChangeAlert.current.inactivate();
                this.props.history.push('/forbidden')
                return
              } else {

                const defaultWantGuideTypeSubcontract = res.Data.want_guide_type_subcontract === null ? cst_want_guide_type[0].default : res.Data.want_guide_type_subcontract;
                this.setState({
                  data: {
                    ...this.state.data,
                    values: {
                      ...res.Data,
                      request_date: moment().format("YYYY-MM-DDT00:00:00"),
                      estimate_deadline: this.state.data.values.estimate_deadline,
                      extend_estimate_natural_id: "",
                      request_natural_id: undefined,
                      id: undefined,
                      want_start_date: "",
                      want_end_date: "",
                      car_qty: "",
                      light_truck_qty: "",
                      truck_qty: "",
                      other_car_qty: "",
                      other_car_detail: "",
                      request_parking_qty: "",
                      survey_status: 0,
                      estimate_create_start_date: undefined,
                      want_guide_type_subcontract: defaultWantGuideTypeSubcontract,
                    }
                  },
                  project: res.Data,
                  customerSystemUseFlag: customerSystemUseFlag
                }, () => {
                  this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.project)
                })
              }
              resolve(res)
            }, () => reject()))
            :
            await new Promise((resolve, reject) =>
              Request.get(projectUrl, {
                project_ulid: this.props.match.params.project_id
              }, res => {
                const customerSystemUseFlag = res.Data.customer_user.customer.customer_system_use_flag;
                if (this.props.data_view_flag == 2 && (res.Data.user_branch != GsuiteAuth.get('user_branch_id'))) {
                  this.props.pageChangeAlert.current.inactivate();
                  this.props.history.push('/forbidden')
                  return
                } else {
                  this.setState({
                    project: res.Data,
                    customerSystemUseFlag: customerSystemUseFlag,
                    data: {
                      ...this.state.data,
                      values: {
                        ...this.state.data.values,
                        user_branch_natural_id: res.Data.user_branch_natural_id,
                        auto_order_display_flag: res.Data.customer_user.customer_branch.auto_order_display_flag ? res.Data.customer_user.customer_branch.auto_order_display_flag : 0
                      }
                    }
                  }, () => {
                    this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.project)
                  });
                }
                resolve(res)
              }, () => reject()))
        : await new Promise((resolve, reject) => Request.get(requestUrl, {}, res => {
          const customerSystemUseFlag = res.Data.customer_system_use_flag;
          if (this.props.data_view_flag == 2 && (res.Data.user_branch_id != GsuiteAuth.get('user_branch_id'))) {
            this.props.pageChangeAlert.current.inactivate();
            this.props.history.push('/forbidden')
            return
          } else {
            const defaultWantGuideTypeSubcontract = res.Data.want_guide_type_subcontract === null ? cst_want_guide_type[0].default : res.Data.want_guide_type_subcontract;
            this.setState({
              data: {
                ...this.state.data,
                values: {
                  ...res.Data,
                  want_guide_type_subcontract: defaultWantGuideTypeSubcontract,

                }
              },
              project: res.Data,
              view: true,
              customerSystemUseFlag: customerSystemUseFlag
            }, () => {
              this.ButtonWithRole = WithRole(Button, this.props.buttons, this.state.project)
            })
          }
          resolve(res)
        }, () => reject()))

      const customerUserApiEndPoint = '/api/customer/user'
      const customer1 = res.Data.customer_user_natural_id && await new Promise((resolve, reject) => {
        Request.get(customerUserApiEndPoint, {
          customer_user_natural_id: res.Data.customer_user_natural_id
        }, res => {
          if (!res.Data[0]) {
            throw {
              name: 'Data Error!',
              message: 'customer1 not exist'
            }
          }
          resolve(res.Data[0])
        }, () => reject())
      })
      const customer2 = (res.Data.subcontract_customer_user_natural_id && await new Promise((resolve, reject) => {
        Request.get(customerUserApiEndPoint, {
          customer_user_natural_id: res.Data.subcontract_customer_user_natural_id
        }, res => {
          if (!res.Data[0]) {
            throw {
              name: 'Data Error!',
              message: 'customer2 not exist'
            }
          }
          resolve(res.Data[0])
        }, () => reject())
      })) || {}
      const extendedRequest = this.props.match.params.estimate_natural_id && await new Promise((resolve, reject) => {
        Request.get('/api/order', {
          estimate_natural_id: this.props.match.params.estimate_natural_id,
          extension_flag: 1
        }, res => {
          if (!res.Data[0]) {
            throw {
              name: 'Data Error!',
              message: 'estimate not exist'
            }
          }
          resolve(res.Data[0])
        }, () => reject())
      })
      let want_start_date = extendedRequest && new Date(extendedRequest.quote_available_end_date)
      want_start_date && want_start_date.setDate(want_start_date.getDate() + 1);
      this.setState({
        customer1,
        customer2,
        data: {
          ...this.state.data,
          values: {
            ...this.state.data.values,
            ...(want_start_date
              ? { want_start_date: moment(want_start_date).format("YYYY-MM-DDT00:00:00") }
              : {})
          },
        },
        want_start_date_disable: Boolean(want_start_date),
      })

    })()
  }
  validate = () => {
    const { customer1, customer2 } = this.state;
    const { want_guide_type, want_guide_type_subcontract } = this.state.data.values;
    const { send_destination_type } = this.state.project
    let message = getErrorCodes(this.state.data.errors)

    let checkGuideType = true;

    // 送付先が「元請けのみに送る」、「両方に送る」の場合チェックする
    if (send_destination_type === 0 || send_destination_type === 2) {
      if (want_guide_type == "0" || want_guide_type == "1") {
        if (!customer1.customer_user_email) {
          checkGuideType = false;
        }
      }

      if (want_guide_type == "0" || want_guide_type == "2") {
        if (!customer1.customer_branch_fax) {
          checkGuideType = false;
        }
      }
    }

    // 送付先が「下請のみに送る」、「両方に送る」の場合チェックする
    if (send_destination_type === 1 || send_destination_type === 2) {
      if (customer2.id && (want_guide_type_subcontract == "0" || want_guide_type_subcontract == "1")) {
        if (!customer2.customer_user_email) {
          checkGuideType = false;
        }
      }
      if (customer2.id && (want_guide_type_subcontract == "0" || want_guide_type_subcontract == "2")) {
        if (!customer2.customer_branch_fax) {
          checkGuideType = false;
        }
      }
    }

    if (checkGuideType === false) {
      message.push(2416)
    }

    if (message.length > 0) {
      this.props.alertModal.current.showErrorModal({ messageNo: message });
      return false;
    }
    return true;
  }

  toggleRegistModal() {
    this.setState({
      regist_modal: !this.state.regist_modal,
      regist_lock: !this.state.regist_lock,
    });
  }
  toggleCopyModal() {
    this.setState({
      copy_modal: !this.state.copy_modal
    });
  }

  customerSelected(customer, target = 'customer1') {
    if (customer) {
      this.setState({
        customer_user_ulid: customer.customer_user_ulid,
        [target]: customer,
      });
    }
  }

  async regist() {
    switch (Number(this.state.request_type)) {
      case 0:
      case 1:
      case 2:
      case 3:
        await this.setState({
          data: {
            ...this.state.data,
            values: {
              ...this.state.data.values,
              user_branch_id: this.state.landmark_user_branch.find(data => data.value === this.state.data.values.user_branch_natural_id).id,
              user_branch_natural_id: this.state.data.values.user_branch_natural_id
            }
          },
          regist_lock: true,
          regist_yes_lock: true,
        })

        // TODO 登録API呼び出し
        const url = domain + '/api/request';
        const {
          data: {
            values
          },
          customer1,
          customer2,
          project
        } = this.state

        if (this.state.view === false) {
          const {
            want_guide_type,
            want_guide_type_subcontract
          } = values
          const {
            customer_id,
            customer_natural_id,
            customer_branch_id,
            customer_branch_natural_id,
            id,
            customer_user_natural_id,
          } = customer1
          const {
            project_natural_id,
            send_destination_type,
            site_customer_user_tel
          } = project
          const {
            customer_branch_natural_id: subcontract_customer_branch_natural_id,
            customer_user_natural_id: subcontract_customer_user_natural_id
          } = customer2
          Request.setProgress(10)
          var extend_estimate_natural_id;
          if (this.state.request_type == 1) {
            extend_estimate_natural_id = this.state.data.values.extend_estimate_natural_id;
          }
          else {
            extend_estimate_natural_id = (this.props.match.params.estimate_natural_id) ? this.props.match.params.estimate_natural_id : "";
          }

          console.log("extend_estimate_natural_id", extend_estimate_natural_id);

          const params = {
            ...values,
            customer_id,
            customer_natural_id,
            customer_branch_id,
            customer_branch_natural_id,
            customer_user_id: id,
            customer_user_natural_id,
            project_ulid: this.props.match.params.project_id,
            request_type: this.state.request_type,
            // #1189 - edit
            //extend_estimate_natural_id: this.props.match.params.estimate_natural_id?this.props.match.params.estimate_natural_id:""
            extend_estimate_natural_id: extend_estimate_natural_id
          };

          Request.setProgress(20)
          const requestCommon = await Request.getRequestCommon({
            customer_branch_natural_id,
            customer_user_natural_id,
            project_natural_id,
            subcontract_customer_branch_natural_id,
            subcontract_customer_user_natural_id,
            REQUEST__request_type: values.request_type,
            REQUEST__cc_email: values.cc_email,
            REQUEST__estimate_deadline: values.estimate_deadline,
            user_branch_natural_id: values.user_branch_natural_id,
            site_customer_user_tel,
          })
          Request.setProgress(30)
          const {
            CUSTOMER_USER__customer_reminder_sms_flag_code,
            CUSTOMER_USER__customer_user_tel
          } = requestCommon.object_customer
          const {
            CUSTOMER_USER__customer_reminder_sms_flag_code: CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract,
            CUSTOMER_USER__customer_user_tel: CUSTOMER_USER__customer_user_tel_subcontract
          } = requestCommon.object_customer_subcontract
          const defaultParams = {
            ...requestCommon
          }
          Request.setProgress(40)
          let a02MailRes = (
            ((send_destination_type == "2" || send_destination_type == "0") && (want_guide_type == "1" || want_guide_type == "0"))
            || ((send_destination_type == "2" || send_destination_type == "1") && (want_guide_type_subcontract == "1" || want_guide_type_subcontract == "0"))
          )
            ? new Promise((resolve, reject) => {
              const mailUrl = '/api/pout/A02_MAIL'
              const mailParams = {
                ...defaultParams,
                send_destination_type: send_destination_type,
                want_guide_type: want_guide_type,
                want_guide_type_subcontract: want_guide_type_subcontract,
                format_url: GoogleDrive.getFormatUrl(format_url.A02_MAIL),
              }
              Request.post(mailUrl, mailParams, res => {
                resolve(res)
              }, err => {
                reject(err)
              })
            })
            : { Code: 200 }

          let a02FaxRes = (
            ((send_destination_type == "2" || send_destination_type == "0") && (want_guide_type == "2" || want_guide_type == "0"))
            || ((send_destination_type == "2" || send_destination_type == "1") && (want_guide_type_subcontract == "2" || want_guide_type_subcontract == "0"))
          )
            ? new Promise((resolve, reject) => {
              const faxUrl = '/api/pout/A02_FAX'
              const faxParams = {
                ...defaultParams,
                send_destination_type: send_destination_type,
                want_guide_type: want_guide_type,
                want_guide_type_subcontract: want_guide_type_subcontract,
                format_url: GoogleDrive.getFormatUrl(format_url.A02_FAX),
              }
              Request.post(faxUrl, faxParams, res => {
                resolve(res)
              }, err => {
                reject(err)
              })
            })
            : { Code: 200 }

          let a02SmsRes = (
            ((send_destination_type == "2" || send_destination_type == "0") && (CUSTOMER_USER__customer_reminder_sms_flag_code == "1" && CUSTOMER_USER__customer_user_tel))
            || ((send_destination_type == "2" || send_destination_type == "1") && (CUSTOMER_USER__customer_reminder_sms_flag_code_subcontract == "1" && CUSTOMER_USER__customer_user_tel_subcontract)
            || site_customer_user_tel)
          )
            ? new Promise((resolve, reject) => {
              // need to fix condition
              const smsUrl = '/api/pout/A02_SMS'
              const smsParams = {
                ...defaultParams,
                send_destination_type: send_destination_type,
                want_guide_type: want_guide_type,
                want_guide_type_subcontract: want_guide_type_subcontract,
                format_url: GoogleDrive.getFormatUrl(format_url.A02_SMS),
              }
              Request.post(smsUrl, smsParams, res => {
                resolve(res)
              }, err => {
                reject(err)
              })
            })
            : { Code: 200 }
          const a02Result = await Promise.all([a02MailRes, a02FaxRes, a02SmsRes]).then(r => r).catch(() => {
            Request.setProgress(0)
            return
          })
          a02MailRes = a02Result && a02Result[0]
          a02FaxRes = a02Result && a02Result[1]
          a02SmsRes = a02Result && a02Result[2]
          Request.setProgress(60)
          if (a02MailRes && a02MailRes.Code == 200 && a02FaxRes && a02FaxRes.Code == 200 && a02SmsRes && a02SmsRes.Code == 200) {
            const resultCode = await new Promise((resolve, reject) => {
              Request.post(url, params, async (res) => {
                if (res.Code == 200) {
                  resolve(res.Code)
                } else {
                  this.props.alertModal.current.showErrorModal({
                    message: res.Message
                  })
                  resolve(res.Code)
                }
              }, error => {
                Request.setProgress(0)
                reject()
                this.props.alertModal.current.showErrorModal({ messageNo: 2402 })
              });
            })
            Request.setProgress(80)

            const sendMailUrl = '/api/send/MAIL'
            a02MailRes.Data && a02MailRes.Data.forEach((mailData) => {
              Request.post(sendMailUrl, mailData, res => {

              }, err => {

              }, undefined, true, false)
            })

            const sendFaxUrl = '/api/send/FAX'
            a02FaxRes.Data && a02FaxRes.Data.forEach((faxData) => {
              Request.post(sendFaxUrl, faxData, res => {

              }, err => {

              }, undefined, true, false)
            })
            // 2520 対応
            const resultSms = await new Promise((resolve, reject) => {
              if (a02SmsRes.Data == undefined) {
                resolve({Code: 200})
              }
              const sendSmsUrl = '/api/send/SMS'
              a02SmsRes.Data && a02SmsRes.Data.forEach((smsData) => {
                if (smsData.site_flag == true) {
                  if (smsData.site_error == true) {
                    const registerType = Number(this.state.project.register_type);
                    // console.log(smsData)
                    if (registerType === 0) {
                      resolve({Code: 200})
                    }else{
                      resolve({Code: 2631})
                    }
                  }else{
                    Request.post(sendSmsUrl, smsData, res => {
                      if (res.Data && res.Data.sms_status == 'accepted'){
                        resolve({Code: 200})
                      }else{
                        resolve({Code: 2631, data: res.Data})
                      }
                    }, err => {
                      resolve({Code: 2631, data: err})
                    }, undefined, true, false)
                  }
                }else{
                  Request.post(sendSmsUrl, smsData, res => {}, err => {}, undefined, true, false)
                }
              })
            })  

            if (resultCode == 200) {
              Request.setProgress(0)
              this.props.pageChangeAlert.current.inactivate()
              if (((send_destination_type == "2" || send_destination_type == "0") && (want_guide_type == "1" || want_guide_type == "0"))
                || ((send_destination_type == "2" || send_destination_type == "1") && (want_guide_type_subcontract == "1" || want_guide_type_subcontract == "0"))) {
                window.open(`https://mail.google.com/mail/u/0/#drafts`);
              }
              
              if (resultSms.Code == 200) {
                this.props.alertModal.current.confirmCheck({
                  title: "処理完了",
                  messageNo: [2417, 2471],
                  closeBtn: false
                }, () => this.props.history.push(this.state.transition_url), false)
              } else {
                console.log(resultSms);
                let title = "エラー"
                let message = GetMessage(2631)
                if (resultSms.data && resultSms.data.sms != "") {
                  message = message + "<br />\n" + resultSms.data.sms
                }
                this.props.alertModal.current.confirmCheck({
                  title: title,
                  message: message ,
                  closeBtn: false
                }, () => this.props.history.push(this.state.transition_url), false)
              }
            }
          } else {
            Request.setProgress(0)
          }

        } else {
          const {
            customer_id,
            customer_natural_id,
            customer_branch_id,
            customer_branch_natural_id,
            id,
            customer_user_natural_id,
          } = customer1;
          const params = {
            ...values,
            customer_id,
            customer_natural_id,
            customer_branch_id,
            customer_branch_natural_id,
            customer_user_id: id,
            customer_user_natural_id,
          };
          Request.put(url + "/" + this.props.match.params.request_seq, params, res => {
            if (res.Code == 200) {
              this.props.pageChangeAlert.current.inactivate()
              this.props.history.push(`/construction/parking/detail/${this.props.match.params.request_seq}${this.state.box_status_param}`)
            }
          }, error => {
            this.props.alertModal.current.showErrorModal({ messageNo: 2403 })
            console.log(error);
          });
        }

        break;
      case 4:
      case 5:
      case 6:
      case 7:
        // this.props.history.push('/construction/other/add/'+this.state.others_type+'/'+this.state.project_id);
        break;
    }
  }

  button_name() {
    if (this.state.view === false) {
      return "登録";
    } else {
      return "更新";
    }
  }

  returnNumber(val) {
    return isNaN(Number(val)) ? 0 : Number(val)
  }

  calculate_SUM_request_parking_qty(values) {
    return this.returnNumber(values.car_qty) + this.returnNumber(values.light_truck_qty) + this.returnNumber(values.truck_qty) + this.returnNumber(values.other_car_qty);
  }

  alertDateCheck(newData) {
    const {
      want_start_date,
      want_end_date
    } = newData.values
    const {
      want_start_date: prev_want_start_date,
    } = this.state.data.values
    if (want_start_date && want_end_date && (moment(want_start_date) > moment(want_end_date))) {
      return {
        ...newData,
        errors: {
          ...newData.errors,
          ...{ [(prev_want_start_date === want_start_date ? 'want_end_date' : 'want_start_date')]: [GetMessage(2431)] },
        }
      }
    } else {
      return newData
    }
  }

  validateCallback(newData, callback = () => { }) {
    const mergedData = {
      ...this.state.data,
      ...this.alertDateCheck(newData)
    }
    this.setState({
      data: {
        ...mergedData,
        values: {
          ...mergedData.values,
          _SUM_request_parking_qty: this.calculate_SUM_request_parking_qty(mergedData.values),
        }
      }
    }, () => callback())
  }
  title_name() {
    if (this.state.view === false) {
      return "依頼（駐車場）登録";
    } else {
      return "依頼（駐車場）更新";
    }
  }
  selectCopyData() {
    let copy_data = this.state.modalData.filter((data) => data.copy_flg == true)
    let estimate_ids = copy_data.map((cd) => { return cd.estimate_natural_id });
    this.setState({
      data: {
        ...this.state.data,
        values: {
          ...this.state.data.values,
          extend_estimate_natural_id: estimate_ids.join(",")
        }
      }
    }, () => this.toggleCopyModal());
  }

  copyToContectMemo() {
    const seletedMemo = this.state.data.values.temp_contact_memo || "";
    this.setState({
      data: {
        ...this.state.data,
        values: {
          ...this.state.data.values,
          contact_memo: seletedMemo
        }
      }
    })
  }

  render() {
    const {
      customer1,
      customer2,
      project
    } = this.state
    const ButtonWithRole = this.ButtonWithRole || WithRole(Button, this.props.buttons, this.state.project)
    // console.log('state',this.state, this.state.modalData)

    const surveyAccountOptions = this.state.userData.reduce((acc, user) => {
      // if(user.user_branch_id == GsuiteAuth.get('user_branch_id')){
      acc.push({
        label: user["name"],
        value: user["id"]
      })
      // }
      return acc
    }, [])
    return (
      <>
        <div className="content" {...{ inert: this.state.regist_lock ? "" : undefined }}>
          <Row>
            <Col md="12">
              <Card>
                <CardHeader>
                  <Row>
                    <Col md="6">
                      <CardTitle tag="h3" className="float-left">{this.title_name()}</CardTitle>
                    </Col>
                    <Col md="6">
                      {this.state.view && <Button className="float-right" onClick={() => {
                        if (this.state.view) {
                          this.customer_select_popup.current.setSelectedDataWithId({
                            customer_natural_id: this.state.data.values.customer_natural_id,
                            customer_branch_natural_id: this.state.data.values.customer_branch_natural_id,
                            customer_user_natural_id: this.state.data.values.customer_user_natural_id
                          });
                        }
                        this.customer_select_popup.current.show();
                      }}>顧客マスタから選択</Button>}
                    </Col>
                  </Row>
                </CardHeader>
                <Col md="11" className="detail">
                  <CardBody>
                    <Table>
                      <tbody>
                        <tr>
                          {/* <th rowSpan='4' className='text-left'>会社情報</th> */}
                          <CustomTd
                            label="会社名"
                            name="CUSTOMER__customer_name"
                            copy={false}
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="支店名"
                            name="CUSTOMER_BRANCH__customer_branch_name"
                            copy={false}
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="電話番号"
                            name="CUSTOMER_BRANCH__customer_branch_tel"
                            copy={false}
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="FAX番号"
                            name="CUSTOMER_BRANCH__customer_branch_fax"
                            copy={false}
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='3' className='text-left'>担当者</th> */}
                          <CustomTd
                            label="顧客担当者"
                            name="CUSTOMER_USER__customer_user_name"
                            copy={false}
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="携帯電話番号"
                            name="CUSTOMER_USER__customer_user_tel"
                            copy={false}
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="固定電話番号"
                            name="CUSTOMER_USER__customer_user_tel2"
                            copy={false}
                            data={customer1}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="メールアドレス"
                            name="CUSTOMER_USER__customer_user_email"
                            copy={false}
                            data={customer1}
                          />
                        </tr>

                        <tr>
                          {/* <th rowSpan='4' className='text-left'>下請顧客会社情報</th> */}
                          <CustomTd
                            label="会社名（下請）"
                            name="CUSTOMER__customer_name"
                            copy={false}
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="支店名（下請）"
                            name="CUSTOMER_BRANCH__customer_branch_name"
                            copy={false}
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="電話番号（下請）"
                            name="CUSTOMER_BRANCH__customer_branch_tel"
                            copy={false}
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="FAX番号（下請）"
                            name="CUSTOMER_BRANCH__customer_branch_fax"
                            copy={false}
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='3' className='text-left'>下請顧客担当者</th> */}
                          <CustomTd
                            label="顧客担当者（下請）"
                            name="CUSTOMER_USER__customer_user_name"
                            copy={false}
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="携帯電話番号（下請）"
                            name="CUSTOMER_USER__customer_user_tel"
                            copy={false}
                            data={customer2}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="固定電話番号（下請）"
                            name="CUSTOMER_USER__customer_user_tel2"
                            copy={false}
                            data={customer2}
                          />
                        </tr>

                        <tr>
                          <CustomTd
                            label="メールアドレス（下請）"
                            name="CUSTOMER_USER__customer_user_email"
                            copy={false}
                            data={customer2}
                          />
                        </tr>

                        <tr>
                          <CustomTd
                            label="現場担当者"
                            name="PROJECT__site_customer_user_name"
                            copy={false}
                            data={this.state.project}
                          />
                        </tr>
                        <tr>
                          <CustomTd
                            label="現場担当者（電話番号）"
                            name="PROJECT__site_customer_user_tel"
                            copy={false}
                            data={this.state.project}
                          />
                        </tr>

                        <tr>
                          {/* <th rowSpan='2' className='text-left'>現場情報</th> */}
                          <CustomTd label='工事番号'
                            name='PROJECT__construction_number'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          <CustomTd label='現場名'
                            name='PROJECT__site_name'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          <CustomTd label='現場名（カナ）'
                            name='PROJECT__site_name_kana'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          <CustomTd label='工事開始日'
                            name='PROJECT__project_start_date'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          <CustomTd label='工事終了日'
                            name='PROJECT__project_finish_date'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          {/* <th rowSpan='3' className='text-left'>現場住所</th> */}
                          <CustomTd label='都道府県'
                            name='PROJECT__site_prefecture'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          <CustomTd label='市区町村'
                            name='PROJECT__site_city'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          <CustomTd label='番地（町名以降）'
                            name='PROJECT__site_address'
                            copy={false}
                            data={this.state.project} />
                        </tr>
                        <tr>
                          <CustomTd
                            label="送付先"
                            name="PROJECT__send_destination_type"
                            copy={false}
                            data={this.state.project}
                          />
                        </tr>
                        <tr>
                          {/* <th className='text-left'>案件担当情報</th> */}
                          <CustomTd label='担当支店'
                            name='REQUEST__user_branch_natural_id'
                            colSpan="3"
                            value={
                              <InputSelect label="担当支店"
                                labelOn={false}
                                validateCallback={this.validateCallback}
                                rootData={this.state.data}
                                validateType="regist"
                                options={this.state.landmark_user_branch}
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='調査担当者'
                            name='REQUEST__web_survey_account'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputSelect
                                label="ユーザ"
                                name="USER__id"
                                options={surveyAccountOptions}
                                rootData={this.state.data.values}
                                validateCallback={this.validateCallback}
                                isSearchable={true}
                              />
                            }
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='3' className='text-left'>依頼情報</th> */}
                          <CustomTd label='依頼種別'
                            name='REQUEST__request_type'
                            copy={false}
                            data={this.state.data.values ? this.state.data.values : ""} />
                        </tr>

                        <tr>
                          <CustomTd label='受付日'
                            name='REQUEST__request_date'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                disabled={true}
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='見積提出期限'
                            name='REQUEST__estimate_deadline'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='2' className='text-left'>利用期間</th> */}
                          <CustomTd label='利用開始日'
                            name='REQUEST__want_start_date'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                disabled={this.state.want_start_date_disable}
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='利用終了日'
                            name='REQUEST__want_end_date'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputDatetime
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='再調査フラグ'
                            name='REQUEST__resurvey_flag'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputCheckBox
                                validateCallback={this.validateCallback}
                                checkedValue={1}
                                uncheckedValue={0}
                              />
                            }
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='6' className='text-left'>利用台数</th> */}
                          <CustomTd label='ワゴン車'
                            name='REQUEST__car_qty'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputNumber
                                validateCallback={this.validateCallback}
                                validateType='regist'
                                unit="台"
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='軽トラック'
                            name='REQUEST__light_truck_qty'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputNumber
                                validateCallback={this.validateCallback}
                                validateType='regist'
                                unit="台"
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='2tトラック'
                            name='REQUEST__truck_qty'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputNumber
                                validateCallback={this.validateCallback}
                                validateType='regist'
                                unit="台"
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='その他（計）'
                            name='REQUEST__other_car_qty'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputNumber
                                validateCallback={this.validateCallback}
                                validateType='regist'
                                unit="台"
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='その他詳細'
                            name='REQUEST__other_car_detail'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText multiline={true}
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='今回利用台数'
                            name='___SUM_request_parking_qty'
                            copy={false}
                            value={this.calculate_SUM_request_parking_qty(this.state.data.values) + "台"} />
                        </tr>
                        <tr>
                          <CustomTd label='顧客からの要望'
                            name='REQUEST__customer_other_request'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText multiline={true}
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='CCメールアドレス'
                            name='REQUEST__cc_email'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputText
                                validateCallback={this.validateCallback}
                                validateType='regist'
                                placeholder="支店マスタに登録されてないCCメールアドレスを入力してください"
                              />
                            }
                          />
                        </tr>
                        <tr>
                          {/* <th rowSpan='5' className='text-left'>希望詳細</th> */}
                          <CustomTd label='案内方法'
                            name='REQUEST__want_guide_type'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                options={cst_want_guide_type}
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        <tr>
                          <CustomTd label='案内方法（下請）'
                            name='REQUEST__want_guide_type_subcontract'
                            copy={false}
                            rootData={this.state.data}
                            value={
                              <InputRadio
                                disabled={!customer2.customer_id}
                                options={cst_want_guide_type}
                                validateCallback={this.validateCallback}
                                validateType='regist'
                              />
                            }
                          />
                        </tr>
                        {this.state.request_type == "1" && (<>
                          <tr>
                            <td className="subTitle">再見積設定</td>
                            <td className="line-break">
                              <Row>
                                <Col md="4">
                                  <InputText
                                    rootData={this.state.data}
                                    name="REQUEST_PARKING__extend_estimate_natural_id"
                                    disabled={true}
                                    placeholder="見積を選択してください"
                                  //                            defaultValue={this.state.data.values.extend_estimate_natural_id}
                                  //                            value={this.state.data.values.extend_estimate_natural_id}
                                  />
                                </Col>
                                <Col md="4">
                                  <Button onClick={() => this.toggleCopyModal()}>見積選択</Button>
                                </Col>
                              </Row>
                            </td>
                          </tr>
                        </>)}
                        {/* 顧客システム利用の場合のみ */}
                        {this.state.customerSystemUseFlag === 1 && (<>
                          <tr style={{ display: 'none' }}>
                            <td className="subTitle">顧客連絡用コメント候補</td>
                            <td className="line-break">
                              <Row>
                                <Col>
                                  <InputSelect
                                    label="顧客連絡用コメント候補"
                                    name="REQUEST__temp_contact_memo"
                                    options={template}
                                    rootData={this.state.data}
                                    validateCallback={this.validateCallback}
                                    isSearchable={true}
                                  />
                                  <Button style={{ marginTop: 10 }} onClick={() => this.copyToContectMemo()}>選択した候補を下へコピー</Button>
                                </Col>
                              </Row>
                            </td>
                          </tr>
                          <tr style={{ display: 'none' }}>
                            <td className="subTitle">顧客連絡用コメント</td>
                            <td className="line-break">
                              <Row>
                                <Col>
                                  <InputText
                                    multiline={true}
                                    name='REQUEST__contact_memo'
                                    rootData={this.state.data}
                                    validateCallback={this.validateCallback}
                                    validateType='regist'
                                  />
                                </Col>
                              </Row>
                            </td>
                          </tr>
                        </>)}
                        {this.state.data.values.auto_order_display_flag == 1 &&
                          <tr>
                            <CustomTd label='自動発注機能'
                              name='REQUEST__auto_order_function_flag'
                              copy={false}
                              rootData={this.state.data}
                              value={
                                <InputRadio
                                  options={cst_auto_order_function_flag}
                                  validateCallback={this.validateCallback}
                                  validateType='regist'
                                />
                              }
                            />
                          </tr>}
                      </tbody>
                    </Table>
                  </CardBody>
                </Col>
                <Row md='12' className="detail">
                  <Col md='6' className="text-center">
                    <Button color="secondary" disabled={this.state.regist_lock} onClick={() => {
                      if (this.state.view === false) {
                        this.props.history.push(this.state.transition_url)
                      } else {
                        this.props.history.push(`/construction/parking/detail/${this.props.match.params.request_seq}${this.state.box_status_param}`)
                      }
                    }}>キャンセル</Button>
                  </Col>
                  <Col md='6' className="text-center">
                    <ButtonWithRole
                      button_id={this.state.view ? "BTN_A2_03_01220" : "BTN_A2_01_01160"}
                      color="info"
                      disabled={this.state.regist_lock}
                      onClick={() => {
                        if (this.validate()) {
                          this.toggleRegistModal()
                        }
                      }}
                    >
                      {this.button_name()}
                    </ButtonWithRole>
                  </Col>
                </Row>

              </Card>
            </Col>
          </Row>
        </div>
        <Modal isOpen={this.state.regist_modal} toggle={this.toggleRegistModal}>
          <div className="modal-header">
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={this.toggleRegistModal}>
              <i className="tim-icons icon-simple-remove"></i>
            </button>
            <h5 className="modal-title">{this.button_name()}</h5>
          </div>
          <ModalBody>
            <p>{this.button_name()}しますか？</p>
          </ModalBody>
          <ModalFooter>
            <Button color="secondary" onClick={this.toggleRegistModal}>
              いいえ
            </Button>
            <ButtonWithRole
              button_id={this.state.view ? "BTN_A2_03_01240" : "BTN_A2_01_01180"}
              color="info"
              disabled={this.state.regist_yes_lock}
              onSubmit={e => { e.preventDefault(); }}
              onClick={() => {
                this.toggleRegistModal()
                this.regist()
              }}>
              はい
            </ButtonWithRole>
          </ModalFooter>
        </Modal>
        <Modal isOpen={this.state.copy_modal} toggle={this.toggleCopyModal} size="lg">
          {this.state.modalData.length > 0 ? (<>
            <ModalHeader className="justify-content-center" toggle={this.toggleCopyModal}>
              再見積する見積を選択してください。
            </ModalHeader>
            <CardBody style={{ overflowY: 'auto', height: '500px' }}>
              <Table className="tablesorter" >
                <thead className="text-primary">
                  <tr>
                    <th className="text-center"></th>
                    <th className="text-center">見積ID</th>
                    <th className="text-center">駐車場名</th>
                    <th className="text-center">駐車場住所</th>
                    <th className="text-center">電話番号</th>
                    <th className="text-center">車種別利用可否</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.modalData.map((modal_data, n) => {
                    const {
                      parking_id,
                      parking_natural_id,
                      estimate_natural_id,
                      survey_parking_name,
                      survey_parking_prefecture: parking_prefecture,
                      survey_parking_city: parking_city,
                      survey_parking_address: parking_address,
                      supplier_tel,
                      survey_capacity_flag_car: capacity_flag_car,
                      survey_capacity_flag_light_truck: capacity_flag_light_truck,
                      survey_capacity_flag_truck: capacity_flag_truck
                    } = modal_data

                    const parkingAddress = <div
                      dangerouslySetInnerHTML={{
                        __html: Definition.item('___JOIN_parking_addr', {
                          parking_prefecture,
                          parking_city,
                          parking_address
                        })
                      }}
                    />
                    const parkingCapacityFlags = <div
                      dangerouslySetInnerHTML={{
                        __html: Definition.item('___JOIN_parking_capacity_flags', {
                          capacity_flag_car,
                          capacity_flag_light_truck,
                          capacity_flag_truck
                        })
                      }}
                    />

                    return (<tr>
                      <td>
                        <Input
                          name={"copydata[" + n + "]"}
                          type="checkbox"
                          value={n}
                          defaultChecked={modal_data.copy_flg}
                          disabled={(modal_data.disabled != undefined) ? modal_data.disabled : false}
                          onClick={(e) => {
                            let n = e.target.value;
                            let selectParkingId = null;
                            let selectData = this.state.modalData[n];
                            //                          if ( !selectData.copy_flg ) {
                            selectParkingId = selectData.parking_natural_id
                            //                          }

                            let newModalData = this.state.modalData.map((data, i) => {
                              // 選択されたデータの処理
                              if (i == n) {
                                return { ...data, copy_flg: !data.copy_flg, disabled: false }
                              }
                              //　それ以外
                              else {
                                // 駐車場IDが一致している場合
                                if (selectParkingId != null && data.parking_natural_id == selectParkingId) {
                                  return { ...data, disabled: !selectData.copy_flg };
                                }
                                else {
                                  return data;
                                }
                              }

                              //                            return (i == n)? {...data,copy_flg:!data.copy_flg}: data;
                            });
                            this.setState({ modalData: newModalData });
                          }}
                        />
                      </td>
                      <td>{estimate_natural_id}</td>
                      <td>{survey_parking_name}</td>
                      <td>{parkingAddress}</td>
                      <td>{supplier_tel}</td>
                      <td>{parkingCapacityFlags}</td>
                    </tr>);
                  })}
                </tbody>
              </Table>
            </CardBody>
            <ModalBody>
              <Card>
                <CardBody>
                  <Row>
                    <Col>
                      <Button className="pos_center" onClick={this.toggleCopyModal}>キャンセル</Button>
                    </Col>
                    <Col>
                      <Button className="btn btn-info" onClick={() => { this.selectCopyData() }}>選択</Button>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </ModalBody>
          </>) : (<>
            <ModalHeader className="justify-content-center" toggle={this.toggleCopyModal}>
              該当する見積がありません。
            </ModalHeader>
            <ModalBody>
              <Card>
                <CardBody>
                  <Button className="pos_center" onClick={this.toggleCopyModal}>閉じる</Button>
                </CardBody>
              </Card>
            </ModalBody>
          </>)}
        </Modal>
        <CustomerSelectPopupWithOrder
          buttons={this.props.buttons}
          view={this.state.view}
          ref={this.customer_select_popup}
          customerSelectedCallback={(customer) => this.customerSelected(customer, 'customer1')}
        />
      </>
    );

  }
}

export default Regist;
